// Map service functions for path visibility and display logic


export const getVisiblePaths = (currentMode, autoPath, customPath) => {
  if (currentMode === 'Comparison Mode') {
    // Show both paths for comparison
    return {
      auto: autoPath,
      custom: customPath
    };
  } else if (currentMode === 'Auto Find Path') {
    // Show only auto-generated path
    return {
      auto: autoPath
    };
  } else if (currentMode === 'Custom Path') {
    // Show only custom path
    return {
      custom: customPath
    };
  }
  // Default: no paths visible
  return {};
};


export const shouldShowAutoPath = (currentMode) => {
  return currentMode === 'Auto Find Path' || currentMode === 'Comparison Mode';
};


export const shouldShowCustomPath = (currentMode) => {
  return currentMode === 'Custom Path' || currentMode === 'Comparison Mode';
};



export const getMapContainerClassName = (currentMode, setupSubmode) => {
  let className = "map-container";
  
  // Show crosshair cursor when marking points on map
  if (currentMode === 'Setup Path Points' && setupSubmode === 'Map Point Marking') {
    className += " map-point-mode";
  }
  
  // Show pointer cursor in custom path mode
  if (currentMode === 'Custom Path') {
    className += " map-custom-mode";
  }
  
  // Show pointer cursor in connection mode
  if (currentMode === 'Connection Mode') {
    className += " map-connection-mode";
  }
  
  return className;
};

export const isMapClickAddPointEnabled = (currentMode, setupSubmode) => {
  return currentMode === 'Setup Path Points' && setupSubmode === 'Map Point Marking';
};

export const isPointSelectionEnabled = (currentMode) => {
  return currentMode === 'Custom Path' || currentMode === 'Connection Mode';
}; 